import React from "react";
import { useNavigate } from "react-router-dom";
import $user from "@/core/user/store";
import $projects from "@/core/projects/store";
import $translations from "@/core/translations/store";
import { observer } from "mobx-react";
import { styled } from "@mui/material";
import ButtonBase from "@mui/material/ButtonBase";
import Box from "@mui/material/Box";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Avatar from "@mui/material/Avatar";
import PersonIcon from "@mui/icons-material/Person";
import Typography from "@mui/material/Typography";

const ButtonWrapper = styled(ButtonBase)(({ theme }) => ({
  textAlign: "left",
  padding: theme.spacing(1),
  marginLeft: theme.spacing(1),
  marginRight: theme.spacing(-1),
  borderRadius: theme.shape.borderRadius,
  maxWidth: 300,
  "& > div:first-of-type": {
    marginRight: theme.spacing(1),
  },
  "& > div:nth-of-type(2)": {
    flex: 1,
    overflow: "hidden",
    "& > div": {
      fontWeight: "bold",
    },
  },
}));

const UserPanel = (props) => {
  const [anchorElUser, setAnchorElUser] = React.useState(null);
  const navigate = useNavigate();

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const handleExit = async () => {
    if (
      $translations.changed &&
      !window.confirm("Есть несохранённые изменения. Выйти и потерять их?")
    ) {
      return;
    }

    await $user.logout();

    // Сбрасываем данные проекта: иначе строки предыдущей учётной записи
    // переживают смену пользователя в том же браузере.
    // Сбрасываем и сам список, а не только активный проект: иначе до
    // резолва fetchData новый пользователь видит карточки предыдущего,
    // причём кликабельные.
    $projects.setData([]);
    $projects.setActive(undefined);
    $translations.destroy();
  };

  return (
    <Box sx={{ flexGrow: 0 }}>
      <ButtonWrapper edge="end" onClick={handleOpenUserMenu}>
        <Avatar size={5}>
          <PersonIcon />
        </Avatar>
        <div>
          <Typography noWrap variant="body2" component="div">
            {$user.username}
          </Typography>
          <Typography variant="caption" color="textSecondary">
            {$user.role}
          </Typography>
        </div>
      </ButtonWrapper>
      <Menu
        sx={{ mt: "55px" }}
        id="menu-appbar"
        anchorEl={anchorElUser}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        keepMounted
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={Boolean(anchorElUser)}
        onClose={handleCloseUserMenu}
      >
        <MenuItem
          onClick={() => {
            handleCloseUserMenu();
            navigate("/api-keys");
          }}
        >
          <Typography>API-ключи</Typography>
        </MenuItem>
        <MenuItem onClick={handleExit}>
          <Typography>Выход</Typography>
        </MenuItem>
      </Menu>
    </Box>
  );
};

export default observer(UserPanel);
